import React from 'react'
import './GetStarted.css'

 function GetStarted() {
  return (
    <>
    <div className="g-wrapper">
        <div className=" g-container">
        <h1 className='orangeText'>  Get Started with Real Estate </h1>
        <h1 className='secondaryText'>Find Your Property Soon...</h1>
        <br/>
        <button className='button'><a href='mailto:snehachaudhari042@gmail.com'>GET STARTED </a></button>
    </div>
    </div>
    </>
  )
}
export default GetStarted
